import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../../../common/constants/dsClasses';
import {
  deliveryDetailsMsg,
  invoicingDetailsMsg,
  orderingContactMsg,
  shippingAddressMsg,
  t,
} from '../../../../common/i18n';
import { Grid } from '../../../Grid/Grid';
import type { JSX } from 'react';

import './OrderInfo.scss';

export interface OrderInfoProps {
  mainTitle: string;
  orderContactInfo: OrderContactInfo;
  deliveryInfo: DeliveryInfo;
  invoicingInfo?: InvoicingInfo;
  gutter?: boolean;
  headerLevel?: 'h2' | 'h3';
  horizontalPadding?: boolean;
  justifyCenter?: boolean;
  showBackgroundColor?: boolean;
  showBorder?: boolean;
}
export interface OrderContactInfo {
  fields: string[];
}
export interface DeliveryInfo {
  deliveryFields: string[];
  deliveryInfo?: JSX.Element;
}
export interface InvoicingInfo {
  left?: JSX.Element;
  right?: JSX.Element;
}

export const OrderInfo = ({
  mainTitle,
  orderContactInfo,
  deliveryInfo,
  invoicingInfo,
  gutter,
  headerLevel = 'h3',
  horizontalPadding = true,
  justifyCenter,
  showBackgroundColor,
  showBorder = true,
}: OrderInfoProps) => {
  const Header = headerLevel;

  return (
    <div
      className={classNames(
        'of-order-info',
        showBackgroundColor ? 'of-order-info-background' : undefined,
        showBorder ? 'of-order-info-border' : undefined
      )}
    >
      <Grid
        className={classNames(
          horizontalPadding ? dsClass.PADDING_HORIZONTAL_4 : undefined,
          dsClass.PADDING_BOTTOM_3,
          dsClass.PADDING_TOP_5
        )}
        gutter={gutter}
        justifyCenter={justifyCenter}
      >
        <Header
          className={classNames(
            'of-order-info-bottom-border-divider',
            dsClass.MARGIN_BOTTOM_4,
            dsClass.PADDING_BOTTOM_4
          )}
        >
          {mainTitle}
        </Header>
        <CL.Description
          listTitle={t.IY5V(orderingContactMsg)}
          className={classNames(
            'of-order-info-bottom-border-divider',
            dsClass.MARGIN_BOTTOM_4,
            dsClass.PADDING_BOTTOM_3
          )}
          items={[
            {
              description: (
                <ul>
                  {orderContactInfo.fields.map((field, index) => (
                    <li key={index}>{field}</li>
                  ))}
                </ul>
              ),
            },
          ]}
        />
        {(deliveryInfo.deliveryFields.length > 0 || deliveryInfo.deliveryInfo) && (
          <CL.Description
            listTitle={t.T78Y(deliveryDetailsMsg)}
            className={classNames(
              'of-order-info-bottom-border-divider',
              dsClass.MARGIN_BOTTOM_4,
              dsClass.PADDING_BOTTOM_3
            )}
            items={[
              ...(deliveryInfo.deliveryFields.length > 0
                ? [
                    {
                      description: (
                        <>
                          <h4>{t.P2E3(shippingAddressMsg)}</h4>
                          <ul>
                            {deliveryInfo.deliveryFields.map((field, index) => (
                              <li key={index}>{field}</li>
                            ))}
                          </ul>
                        </>
                      ),
                    },
                  ]
                : []),
              {
                description: deliveryInfo.deliveryInfo,
              },
            ]}
          />
        )}
        {invoicingInfo && (
          <CL.Description
            listTitle={t.RPMR(invoicingDetailsMsg)}
            className={classNames(dsClass.PADDING_BOTTOM_3)}
            items={[
              {
                description: invoicingInfo.left,
              },
              {
                description: invoicingInfo.right,
              },
            ]}
          />
        )}
      </Grid>
    </div>
  );
};
